<template>

  <v-layout row justify-center>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

      <v-card>

        <v-toolbar app clipped-left fixed prominent dark color="primary">

          <v-btn icon @click.native="dialog = false">
            <v-icon>arrow_back</v-icon>
          </v-btn>

          <v-toolbar-title v-text="'Sobre'"></v-toolbar-title>

        </v-toolbar>

        <v-content>

          <v-container fluid grid-list-lg>
            <v-layout row wrap>

              <v-flex xs12>
                <p class="text-xs-center my-2">
                  <img src="/static/img/stamp.png" />
                </p>
              </v-flex>

              <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
                <v-card class="px-3 py-2">
                  <v-card-text>
                    <p>
                      O aplicativo <strong>Arbopasto</strong> foi desenvolvido pela parceria da
                      <a href="https://embrapa.br/rondonia" target="_blank">Embrapa Rondônia</a>,
                      <a href="https://embrapa.br/acre" target="_blank">Embrapa Acre</a> e 
                      <a href="https://embrapa.br/gado-de-corte" target="_blank">Embrapa Gado de Corte</a> com apoio da 
                      <a href="https://facom.ufms.br" target="_blank">Faculdade de Computação - FACOM</a> da
                      <a href="https://ufms.br" target="_blank">Universidade Federal de Mato Grosso do Sul - UFMS</a>.
                      É mantido pelo <a href="http://please.cnpgc.embrapa.br" target="_blank">Laboratory
                      for Precision Livestock, Environment and Software Engineering - PLEASE Lab</a>.
                    </p>
                    <p>
                      O projeto <strong>Software Arbopasto</strong> teve como agente financiador o <a href="http://www.bancoamazonia.com.br" target="_blank">Banco da Amazônia</a>, com sede localizada em Belém - PA.
                    </p>
                    <p>
                      Encontrou algum problema ou tem alguma sugestão? Por favor, nos avise informando o número da versão abaixo, a
                      mensagem de erro e o modelo do seu <em>smartphone</em> pelo nosso
                      e-mail de suporte:.
                    </p>
                    <p class="text-xs-center">
                      <a :href="'mailto: ' + settings.support + '?subject=Problemas%20na%20vers%C3%A3o%20' + version + '%20do%20aplicativo%20Arbopasto'" target="_blank">{{ settings.support }}</a>
                    </p>
                  </v-card-text>
                </v-card>
                <v-img src="/static/img/partners.png" class="mt-5" />
              </v-flex>

              <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
                <p class="body-2 text-xs-center">Versão {{ version }}</p>
              </v-flex>

            </v-layout>
          </v-container>

        </v-content>

      </v-card>

      <beta></beta>
    
    </v-dialog>

  </v-layout>

</template>

<script>
import Beta from './Beta'

var settings = require('../settings/' + process.env.NODE_ENV + '.json')
var pkg = require('../../package.json')

export default {
  components: {
    Beta
  },
  data () {
    return {
      dialog: false,
      version: pkg.version,
      settings: settings
    }
  },
  methods: {
    show () {
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue